import { MenuItem, TextField } from "@mui/material";
import { useGetTreatmentsQuery } from "src/api/services/treatmentsApi";
import { FilterProps } from "src/api/types";

const TreatmentFilter = ({ filter, onChange, placeholder }: FilterProps) => {
  const { data = [] } = useGetTreatmentsQuery();

  return (
    <TextField
      label={placeholder}
      select
      sx={{ width: 180 }}
      size="small"
      value={filter}
      onChange={onChange}
    >
      <MenuItem value={""}>{"None"}</MenuItem>
      {data.map((treatment) => (
        <MenuItem key={treatment.id} value={treatment.name}>
          {treatment.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default TreatmentFilter;
